export const joinPath = (baseUrl, paths) => {
    const fullPath = paths.reduce((acc, path) => {
        const trimmedPath = path.replace(/^\/|\/$/g, '');
        return acc.replace(/\/$/, '') + '/' + trimmedPath;
    }, baseUrl.replace(/\/$/, ''));
    return fullPath
}
